import { render, staticRenderFns } from "./BlogHeader.vue?vue&type=template&id=77b19506&scoped=true&lang=pug&"
import script from "./BlogHeader.vue?vue&type=script&lang=js&"
export * from "./BlogHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlogHeader.vue?vue&type=style&index=0&id=77b19506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b19506",
  null
  
)

export default component.exports